import { Divider } from '@/components/layout/divider';
import { Scroll } from '@/components/layout/scroll';
import { Stack } from '@/components/layout/stack';
import { SheetContent, SheetModal, SheetModalTrigger, SvgIcon } from '@/components/ui';
import Text from '@/components/ui/text/text';
import { STRINGS } from '@/constants/strings';
import { KitItem } from '@/features/player/components/player-profile/player-equipment/kit-item';
import { useStyles } from '@/features/player/components/player-profile/player-equipment/styles';
import { PlayerWelcomeKit } from '@/features/player/components/types';
import { useBottomInsetSmart, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { Activity, useState } from 'react';
import { Platform, StyleSheet, TouchableOpacity } from 'react-native';

export function ListKitsSheetModal({ welcomeKit }: { welcomeKit: PlayerWelcomeKit[] }) {
  const styles = useStyles();
  const { scale, isTablet } = useScaling();
  const [showAllKits, setShowAllKits] = useState(false);
  const bottomInset = useBottomInsetSmart();

  const close = () => setShowAllKits(false);

  return (
    <SheetModal open={showAllKits} onOpenChange={setShowAllKits}>
      <SheetModalTrigger>
        <Text variant="Font Inter/Subtitle/Regular 12px" style={styles.showAll}>
          {STRINGS.player.profile.equipment.showAll}
        </Text>
      </SheetModalTrigger>
      <SheetContent tabletWidth={scale(375)} closeOnBackdropPress={false} style={styles.sheet}>
        <Activity mode={!welcomeKit.length ? 'visible' : 'hidden'}>
          <Stack
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            justify="center"
            align="center">
            <Stack direction="column" paddingY={scale(16)} borderRadius={scale(12)}>
              <Text variant="Font Inter/Subtitle/Regular 12px">
                {STRINGS.player.profile.equipment.noKits}
              </Text>
            </Stack>
          </Stack>
        </Activity>
        <Stack
          direction="column"
          flex={Platform.OS === 'web' ? 1 : undefined}
          minHeight={Platform.OS === 'web' ? 0 : undefined}
          backgroundColor={colors['1']}
          paddingBottom={bottomInset}>
          <Stack direction="row" align="center" style={styles.sheetHeader} backgroundColor="white">
            <TouchableOpacity onPress={close} hitSlop={scale(12)} style={styles.headerSide}>
              <Stack direction="row" align="center" gap={scale(2)}>
                <SvgIcon name="IcBackBlue" size={24} />
                <Text
                  variant={
                    isTablet ? 'Font Inter/Subtitle/Regular 12px' : 'Font Inter/Subtitle/Medium'
                  }
                  style={styles.headerActionText}>
                  {STRINGS.player.profile.header.back}
                </Text>
              </Stack>
            </TouchableOpacity>

            <Stack flex={1} align="center">
              <Text
                variant={'Font Montserrat/Subtitle/Minimize 1 Bold 11px'}
                fontWeight={'800'}
                style={styles.sheetTitle}>
                {STRINGS.player.profile.equipment.sheetTitle}
              </Text>
            </Stack>

            <Stack width={scale(60)} />
          </Stack>
          <Divider thickness={StyleSheet.hairlineWidth} />
          <Scroll
            gestureEnabled={Platform.OS !== 'web'}
            style={Platform.OS === 'web' ? styles.sheetScrollViewport : undefined}
            contentContainerStyle={{
              paddingBottom: bottomInset + (bottomInset > 0 ? 20 : 60),
              paddingHorizontal: scale(16),
              paddingTop: scale(16),
            }}>
            <Stack gap={scale(8)}>
              {welcomeKit.map((kit, index) => (
                <KitItem
                  key={`${kit.level}-${kit.date}-${kit.coachName}-${index}`}
                  level={kit.level ?? 0}
                  dateText={kit.date ?? ''}
                  coachName={kit.coachName ?? ''}
                />
              ))}
            </Stack>
          </Scroll>
        </Stack>
      </SheetContent>
    </SheetModal>
  );
}
